import { createFileRoute } from '@tanstack/react-router';
import { ChainCompetenceCompliancePage } from '@/pages/chain/ChainCompetenceCompliancePage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/chain/competence')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainHq.readAnalytics', 'chainHq.read'], redirectTo: '/dashboard' }),
	component: ChainCompetenceCompliancePage,
});
